import React, { useEffect } from "react";
import { monthsData, yearData } from "@/constants/dashboardData";
import { API_ROUTES } from "@/services/environment";
import { GET } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import { USFormatePriceWithoutDecimal } from "@thdinc/hpf-shared";

function centsToDollars(cents: string) {
    return Math.floor(parseInt(cents, 10) / 100).toString();
}

interface RevenueFilterProps {
    selectedMonth: number | string;
    selectedYear: number | string;
    onMonthChange: (month: number | string) => void;
    onYearChange: (year: number | string) => void;
    onRevenueChange: (revenue: string) => void;
    onLoadingChange?: (isLoading: boolean) => void;
}

export const RevenueFilter: React.FC<RevenueFilterProps> = ({
    selectedMonth,
    selectedYear,
    onMonthChange,
    onYearChange,
    onRevenueChange,
    onLoadingChange,
}) => {
    const { getRevenueApi } = API_ROUTES;
    const { refreshToken, business_id } = useAppSelector((store) => store.user);
    const { currentBusiness } = useAppSelector((store) => store.business);
    // const [monthRang, setMonthRang] = useState<any[]>([]);

    useEffect(() => {
        (async () => {
            try {
                onLoadingChange?.(true);
                const res = await GET(
                    `${getRevenueApi}?business_id=${currentBusiness ? currentBusiness : business_id}&month=${selectedMonth}&year=${selectedYear}`,
                    refreshToken
                );
                onRevenueChange(
                    `$${USFormatePriceWithoutDecimal(centsToDollars(res.data.data.total_revenue))}`
                );
            } catch (error) {
                console.log(error);
            } finally {
                onLoadingChange?.(false);
            }
        })();
        // setMonthRang(
        //     monthsData.filter((m) => {
        //         if (
        //             selectedYear.toString() === new Date().getFullYear().toString()
        //         ) {
        //             return (
        //                 m.value <= new Date().getMonth().toString() || m.value === "YTD"
        //             );
        //         }
        //         return true;
        //     })
        // );
    }, [selectedMonth, selectedYear, currentBusiness, business_id]);

    return (
        <div className="flex flex-row gap-3 w-full sm:w-28 sm:flex-col sm:items-end">
            <select
                className="select-wrapper text-xs rounded-full cursor-pointer focus:outline-none focus:ring-1 focus:ring-primary-red w-full"
                onChange={(e) => onMonthChange(e.target.value)}
                value={selectedMonth}
            >
                {/* {monthRang.map((r: any) => ( */}
                {monthsData.map((r: any) => (
                    <option key={r.value} value={r.value}>
                        {r.label}
                    </option>
                ))}
            </select>
            <select
                className="select-wrapper text-xs rounded-full cursor-pointer focus:outline-none focus:ring-1 focus:ring-primary-red w-full"
                onChange={(e) => onYearChange(e.target.value)}
                value={selectedYear}
            >
                {yearData.map((r: any) => (
                    <option key={r.value} value={r.value}>
                        {r.label}
                    </option>
                ))}
            </select>
        </div>
    );
};
